// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c4782cf0","239":"01cbc229","453":"758aad29","455":"90d01b54","762":"31c95131"}[chunkId] + ".chunk.js";
};